import "./styles.css";
export default function HeroHomeDonneurOrdre() {
    return (
        <section className="heroDonneurOrdre">
            <div>
                <h1>Bienvenue sur l'espace Donneur d'ordre d'INTERESEAUX</h1>
                <h2>Trouvez facilement vos partenaires sur INTERESEAUX</h2>
                <p>
                    Vous êtes une entreprise ou un acteur avec des projets ambitieux ? Simplifiez la recherche de prestataires qualifiés.
                    Déposez vos appels d’offres ou explorez notre réseau pour identifier les partenaires adaptés à vos besoins.
                </p>
                <p>
                    Accédez à des prestataires fiables, comparez les propositions et optimisez vos collaborations pour gagner du temps et sécuriser vos projets.
                </p>
                <p>
                    Que vous soyez une PME ou un grand groupe, INTERESEAUX vous offre un espace dédié pour gérer vos appels d’offres et vos partenaires en toute simplicité.
                </p>
            </div>
        </section>

    )
}
